<template>
<div>
    <official-fee-form :getOfficialFeeList="getOfficialFeeList" ref="officialFeeFormModal"></official-fee-form>
    <div class="custom-search">
        <b-row>
            <b-col class="col-md-2">
                <label for="official-fee-recordNo-input">{{ $t('officialFee.record_no') }}</label>
                <b-form-input v-on:keyup.enter="getOfficialFeeList()" :placeholder="$t('officialFee.record_no')" size="sm" id="official-fee-recordNo-input" v-model="recordNo" maxlength="12" />
            </b-col>
            <b-col class="col-md-2">
                <label for="official-fee-receiptNo-input">{{ $t('officialFee.receipt_no') }}</label>
                <b-form-input v-on:keyup.enter="getOfficialFeeList()" :placeholder="$t('officialFee.receipt_no')" size="sm" id="official-fee-receiptNo-input" v-model="receiptNo" maxlength="50" />
            </b-col>
            <b-col class="col-md-2">
                <label for="official-fee-employee-input">{{ $t('officialFee.employee') }}</label>
                <b-form-select @change="getOfficialFeeList()" id="official-fee-employee-input" size="sm" v-model="employeeSelect" value-field="id" text-field="name" :options="employeeOption" />
            </b-col>
            <b-col class="col-md-2">
                <label for="official-fee-name-input">{{ $t('officialFee.official_fee_name') }}</label>
                <b-form-input v-on:keyup.enter="getOfficialFeeList()" :placeholder="$t('officialFee.official_fee_name')" size="sm" id="official-fee-name-input" v-model="name" maxlength="500" />
            </b-col>
            <b-col class="col-md-4 mt-2 custom-search d-flex justify-content-end">
                <div class="d-flex align-items-center">
                    <b-button style="float:right;" class="mr-05" size="sm" variant="outline-primary" v-on:keyup.enter="getOfficialFeeList()" @click="getOfficialFeeList()">{{ $t('others.list') }}</b-button>
                    <b-button style="float:right;" class="mr-05" size="sm" variant="outline-primary" @click="getInfo(0)">{{ $t('officialFee.add') }}</b-button>
                    <b-button style="float:right;" class="mr-05" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button>
                    <b-button style="float:right;" class="mr-05" size="sm" variant="outline-primary" @click="clearSearchForm"> {{ $t('others.clear') }}</b-button>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-collapse class="mb-1" accordion type="margin">
                    <app-collapse-item :title="$t('others.search')">
                        <b-row>
                            <b-col class="col-md-2 mb-1">
                                <label for="official-fee-module-input">{{ $t('officialFee.module') }}</label>
                                <b-form-select @change="getOfficialFeeList()" id="official-fee-module-input" size="sm" v-model="moduleSelect" value-field="id" text-field="name" :options="moduleOption" />
                            </b-col>
                            <b-col class="col-md-2 mb-1">
                                <label for="official-fee-type-input">{{ $t('officialFee.official_fee_type') }}</label>
                                <b-form-select @change="getOfficialFeeList()" id="official-fee-type-input" size="sm" v-model="officialFeeTypeSelect" value-field="id" text-field="name" :options="officialFeeTypeOption" />
                            </b-col>
                            <b-col class="col-md-2 mb-1">
                                <label for="official-fee-refund-status-input">{{ $t('officialFee.official_fee_refund_status') }}</label>
                                <b-form-select @change="getOfficialFeeList()" id="official-fee-refund-status-input" size="sm" v-model="officialFeeRefundStatusSelect" value-field="id" text-field="name" :options="officialFeeRefundStatusOption" />
                            </b-col>
                            <b-col class="col-md-2 mb-1">
                                <label for="official-fee-owner-type-input">{{ $t('officialFee.official_fee_owner_type') }}</label>
                                <b-form-select @change="getOfficialFeeList()" id="official-fee-owner-type-input" size="sm" v-model="officialFeeOwnerTypeSelect" value-field="id" text-field="name" :options="officialFeeOwnerTypeOption" />
                            </b-col>
                            <b-col class="col-md-2 mb-1">
                                <label for="official-fee-credit-card-input">{{ $t('officialFee.credit_card') }}</label>
                                <b-form-select @change="getOfficialFeeList()" id="official-fee-credit-card-input" size="sm" v-model="creditCardSelect" value-field="id" text-field="name" :options="creditCardOption" />
                            </b-col>
                            <b-col class="col-md-2">
                                <label for="official-fee-document_no-input">{{ $t('officialFee.document_no') }}</label>
                                <b-form-input v-on:keyup.enter="getOfficialFeeList()" :placeholder="$t('officialFee.document_no')" size="sm" id="official-fee-document-no-input" v-model="documentNo" maxlength="20" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="col-md-2">
                                <label for="official-fee-document-date-start-input">{{ $t('officialFee.document_date_start') }}</label>
                                <CustomDatePicker :datePickerValidateOption="0" v-model="documentDateStart"></CustomDatePicker>
                            </b-col>
                            <b-col class="col-md-2">
                                <label for="official-fee-document-date-end-input">{{ $t('officialFee.document_date_end') }}</label>
                                <CustomDatePicker :datePickerValidateOption="0" v-model="documentDateEnd"></CustomDatePicker>
                            </b-col>
                            <b-col class="col-md-2">
                                <label for="official-fee-receipt-date-start-input">{{ $t('officialFee.receipt_date_start') }}</label>
                                <CustomDatePicker :datePickerValidateOption="0" v-model="receiptDateStart"></CustomDatePicker>
                            </b-col>
                            <b-col class="col-md-2">
                                <label for="official-fee-receipt-date-end-input">{{ $t('officialFee.receipt_date_end') }}</label>
                                <CustomDatePicker :datePickerValidateOption="0" v-model="receiptDateEnd"></CustomDatePicker>
                            </b-col>
                            <b-col class="col-md-2">
                                <label for="official-fee-price-start-input">{{ $t('officialFee.price_start') }}</label>
                                <b-form-input v-on:keyup.enter="getOfficialFeeList()" :placeholder="$t('officialFee.price_start')" size="sm" id="official-fee-price-start-input" v-model="priceStart" />
                            </b-col>
                            <b-col class="col-md-2">
                                <label for="official-fee-price-end-input">{{ $t('officialFee.price_end') }}</label>
                                <b-form-input v-on:keyup.enter="getOfficialFeeList()" :placeholder="$t('officialFee.price_end')" size="sm" id="official-fee-price-end-input" v-model="priceEnd" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="col-md-2">
                                <label for="official-fee-currency-input">{{ $t('officialFee.currency') }}</label>
                                <b-form-select @change="getOfficialFeeList()" id="official-fee-currency-input" size="sm" v-model="currencySelect" value-field="id" text-field="code" :options="currencyOption" />
                            </b-col>
                            <b-col class="col-md-2">
                                <label for="official-fee-client-accounting-input">{{ $t('officialFee.client_accounting') }}</label>
                                <b-form-input v-on:keyup.enter="getOfficialFeeList()" :placeholder="$t('officialFee.client_accounting')" size="sm" id="official-fee-client-accounting-input" v-model="clientAccounting" />
                            </b-col>
                            <b-col class="col-md-2">
                                <label for="official-fee-payment-institution-input">{{ $t('officialFee.official_fee_payment_institution') }}</label>
                                <b-form-select v-on:keyup.enter="getOfficialFeeList()" id="official-fee-payment-institution-input" size="sm" v-model="paymentInstutionSelect" value-field="id" text-field="name" :options="paymentInstutionOption" />
                            </b-col>
                            <b-col class="col-md-2 mt-1">
                                <!-- STOCK-2063 We Change perfectly checkbox why i dont understand  -->
                                <!-- <label for="is-matched-invoices-input">{{ $t('officialFee.matched_invoices') }}</label>
                                    <b-form-checkbox class="custom-control-success" name="is-matched-invoices-input" id="is-matched-invoices-input" v-model="isMatchedInvoices" switch @change="getOfficialFeeList()">
                                        <span class="switch-icon-left">
                                            <feather-icon icon="CheckIcon" />
                                        </span>
                                        <span class="switch-icon-right">
                                            <feather-icon icon="XIcon" />
                                        </span>
                                    </b-form-checkbox> -->
                                <label for="official-fee-is-matched-invoices-input">{{ $t('officialFee.matched_invoices') }}</label>
                                <b-form-select @change="getOfficialFeeList()" id="official-fee-is-matched-invoices-input" size="sm" v-model="isMatchedInvoicesSelect" value-field="id" text-field="name" :options="isMatchedInvoicesOption" />
                            </b-col>
                            <b-col class="col-md-2 mt-1">
                                <label for="official-fee-e-invoice-date-start-input">{{ $t('officialFee.e_invoice_date_start') }}</label>
                                <CustomDatePicker :datePickerValidateOption="0" v-model="einvoiceDateStart"></CustomDatePicker>
                            </b-col>
                            <b-col class="col-md-2 mt-1">
                                <label for="official-fee-e-invoice-date-end-input">{{ $t('officialFee.e_invoice_date_end') }}</label>
                                <CustomDatePicker :datePickerValidateOption="0" v-model="einvoiceDateEnd"></CustomDatePicker>
                            </b-col>
                        </b-row>
                    </app-collapse-item>
                </app-collapse>
            </b-col>
        </b-row>
    </div>
    <!-- table -->
    <vue-good-table id="officialFeeTable" ref="officialFeeTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }" :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }" :pagination-options="{
        enabled: true,
        perPage: pageLength
      }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'receiptDate'" class="text-nowrap">
                {{ $t('officialFee.receipt_date') }}
            </span>
            <span v-else-if="props.column.field === 'date'" class="text-nowrap">
                {{ $t('officialFee.date') }}
            </span>
            <span v-else-if="props.column.field === 'officialFeeType'" class="text-nowrap">
                {{ $t('officialFee.official_fee_type') }}
            </span>
            <span v-else-if="props.column.field === 'officialFeeOwnerType'" class="text-nowrap">
                {{ $t('officialFee.official_fee_owner_type') }}
            </span>
            <span v-else-if="props.column.field === 'recordNo'" class="text-nowrap">
                {{ $t('officialFee.record_no') }}
            </span>
            <span v-else-if="props.column.field === 'applicationNo'" class="text-nowrap">
                {{ $t('officialFee.application_no') }}
            </span>
            <span v-else-if="props.column.field === 'employee'" class="text-nowrap">
                {{ $t('officialFee.name') }}
            </span>
            <span v-else-if="props.column.field === 'receiptNo'" class="text-nowrap">
                {{ $t('officialFee.receipt_no') }}
            </span>
            <span v-else-if="props.column.field === 'price'" class="text-nowrap">
                {{ $t('officialFee.price') }}
            </span>
            <span v-else-if="props.column.field === 'officialFeeValue'" class="text-nowrap">
                {{ $t('officialFee.official_fee') }}
            </span>
            <span v-else-if="props.column.field === 'currency'" class="text-nowrap">
                {{ $t('officialFee.currency') }}
            </span>
            <span v-else-if="props.column.field === 'invoice_date'" class="text-nowrap">
                {{ $t('officialFee.invoice_date') }}
            </span>
            <span v-else-if="props.column.field === 'invoice_no'" class="text-nowrap">
                {{ $t('officialFee.invoice_no') }}
            </span>
            <span v-else-if="props.column.field === 'officialFeePaymentInstitution'" class="text-nowrap">
                {{ $t('officialFee.official_fee_payment_institution') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                {{ $t('others.process') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Process -->
            <span v-if="props.column.field === 'process'">
                <span>
                    <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.id)">

                        <feather-icon icon="EditIcon" />
                    </b-button>
                    <!-- <b-button v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-1"
                size="sm" @click="deleted(props.row)">
                <feather-icon icon="XIcon" />
              </b-button> -->
                    <span v-if="props.row.incomeInvoiceUUID != null">
                        <b-button v-b-tooltip.html :title="$t('others.show_invoice')" v-b-modal.modal-top variant="info" class="btn-icon mb-1 ml-1" size="sm" @click="getEInvoicePdf(props.row.incomeInvoiceUUID)">
                            <feather-icon icon="EyeIcon" />
                        </b-button>
                    </span>

                </span>
            </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}</span>
                    <b-form-select size="sm" v-model="pageLength" :options="['10','50','100', '1000']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" @change="refreshAfterPerPageChange(props)" />
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getOfficialFeeList()">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    watch: {
        einvoiceDateStart(newValue) {
            if (newValue == '') {
                this.einvoiceDateStart = null
            }
        },
        einvoiceDateEnd(newValue) {
            if (newValue == '') {
                this.einvoiceDateEnd = null
            }
        },
        receiptDateStart(newValue) {
            if (newValue == '') {
                this.receiptDateStart = null
            }
        },
        receiptDateEnd(newValue) {
            if (newValue == '') {
                this.receiptDateEnd = null
            }
        },
        documentDateStart(newValue) {
            if (newValue == '') {
                this.documentDateStart = null
            }
        },
        documentDateEnd(newValue) {
            if (newValue == '') {
                this.documentDateEnd = null
            }
        },
    },
    data() {
        return {
            total: 0,
            pageLength: 10,
            dir: false,
            pageNo: 1,
            columns: [{
                    label: this.$t('officialFee.receipt_date'),
                    field: `receiptDate`,
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('officialFee.date'),
                    field: `date`,
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('officialFee.official_fee_type'),
                    field: `officialFeeType`,
                },
                {
                    label: this.$t('officialFee.official_fee_owner_type'),
                    field: `officialFeeOwnerType`,
                },
                {
                    label: this.$t('officialFee.record_no'),
                    field: `recordNo`,
                },
                {
                    label: this.$t('officialFee.application_no'),
                    field: `applicationNo`,
                },
                {
                    label: this.$t('officialFee.name'),
                    field: `employee`,
                },
                {
                    label: this.$t('officialFee.receipt_no'),
                    field: `receiptNo`,
                },
                {
                    label: this.$t('officialFee.price'),
                    field: `price`,
                    formatFn: this.$formatMoney,
                },
                {
                    label: this.$t('officialFee.official_fee'),
                    field: `officialFeeValue`,
                    formatFn: this.$formatMoney,
                },
                {
                    label: this.$t('officialFee.currency'),
                    field: `currency`,
                },
                {
                    label: this.$t('officialFee.invoice_date'),
                    field: `invoiceDate`,
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('officialFee.invoice_no'),
                    field: `invoiceNo`,
                },
                {
                    label: this.$t('officialFee.official_fee_payment_institution'),
                    field: `officialFeePaymentInstitution`,
                },
                {
                    label: 'Process',
                    field: 'process',
                    width: '7em'
                },
            ],
            rows: [],
            moduleId: 0,
            creditCardId: 0,
            documentNo: '',
            clientAccounting: '',
            employee: '',
            officialFeeTypeId: 0,
            officialFeeOwnerTypeId: 0,
            name: '',
            searchTerm: '',
            recordNo: '',
            receiptNo: '',
            employeeOption: [],
            employeeSelect: 0,
            documentDateStart: null,
            documentDateEnd: null,
            receiptDateStart: null,
            receiptDateEnd: null,
            officialFeeTypeSelect: 0,
            officialFeeTypeOption: [],
            moduleSelect: 0,
            moduleOption: [],
            priceEnd: 0,
            priceStart: 0,
            creditCardSelect: 0,
            creditCardOption: [],
            officialFeeOwnerTypeOption: [],
            officialFeeOwnerTypeSelect: 0,
            officialFeeRefundStatusOption: [],
            officialFeeRefundStatusSelect: 0,
            currencySelect: 0,
            currencyOption: [],
            paymentInstutionSelect: 0,
            paymentInstutionOption: [],
            isMatchedInvoicesOption: [],
            isMatchedInvoicesSelect: 0,
            einvoiceDateEnd: null,
            einvoiceDateStart: null
        }
    },
    mounted() {
        const saved = Number(localStorage.getItem('officialFee_perPage'))
        if (saved) this.pageLength = saved
        this.getOfficialFeeList()
    },
    methods: {
        async deleted(data) {
            data = {
                id: data.id
            }
            const controller = {
                name: 'OfficialFee'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$DeleteConfirm().then(result => {
                if (result.value) {
                    this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$DeleteAlert()
                            this.getOfficialFeeList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                            this.getOfficialFeeList()
                        }
                    })
                }
            })
        },
        async getInfo(id) {
            this.$refs.officialFeeFormModal.showInfo(id)
        },
        getOfficialFeeList() {
            this.rows = []
            const data = {
                pageLength: this.pageLength,
                pageNo: this.pageNo,
                moduleId: this.moduleSelect,
                creditCardId: this.creditCardSelect,
                employeeId: this.employeeSelect,
                officialFeeTypeId: this.officialFeeTypeSelect,
                officialFeeOwnerTypeId: this.officialFeeOwnerTypeSelect,
                currencyId: this.currencySelect,
                officialFeeRefundStatusId: this.officialFeeRefundStatusSelect,
                priceStart: this.priceStart,
                priceEnd: this.priceEnd,
                recordNo: this.recordNo,
                receiptNo: this.receiptNo,
                receiptDateStart: this.receiptDateStart,
                receiptDateEnd: this.receiptDateEnd,
                documentDateStart: this.documentDateStart,
                documentDateEnd: this.documentDateEnd,
                name: this.name,
                officailFeeTypeId: this.officialFeeTypeId,
                documentNo: this.documentNo,
                clientAccounting: this.clientAccounting,
                name: this.name,
                currencyId: this.currencySelect,
                paymentInstutionId: this.paymentInstutionSelect,
                isMatchedInvoices: this.isMatchedInvoicesSelect,
                einvoiceDateEnd: this.einvoiceDateEnd,
                einvoiceDateStart: this.einvoiceDateStart
            }
            const controller = {
                name: 'OfficialFee'
            }
            const payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/getList', payload).then((response) => {
                this.total = response.data.total
                if (response.data.resultStatus == true) {
                    this.employeeOption = response.data.employeeList
                    this.officialFeeTypeOption = response.data.officialFeeTypeList
                    this.officialFeeOwnerTypeOption = response.data.officialFeeOwnerTypeList
                    this.officialFeeRefundStatusOption = response.data.officialFeeRefundStatusList
                    this.moduleOption = response.data.moduleList
                    this.currencyOption = response.data.currencyList
                    this.creditCardOption = response.data.creditCardList
                    this.paymentInstutionOption = response.data.officialFeePaymentInstitutionList
                    this.isMatchedInvoicesOption = response.data.isMatchedInvoicesSelectList
                    this.employeeOption.splice(0, 0, this.$nullSelected("name"))
                    this.officialFeeRefundStatusOption.splice(0, 0, this.$nullSelected("name"))
                    this.officialFeeOwnerTypeOption.splice(0, 0, this.$nullSelected("name"))
                    this.officialFeeTypeOption.splice(0, 0, this.$nullSelected("name"))
                    this.moduleOption.splice(0, 0, this.$nullSelected("name"))
                    this.currencyOption.splice(0, 0, this.$nullSelected("code"))
                    this.creditCardOption.splice(0, 0, this.$nullSelected("name"))
                    this.paymentInstutionOption.splice(0, 0, this.$nullSelected("name"))
                    // this.isMatchedInvoicesOption.splice(0, 0, this.$nullSelected("name"))
                    this.rows = response.data.officialFeeList
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
        refreshAfterPerPageChange(slotProps) {
            //sayfanın pagination number'ını tutuyor ve sayfayı yeniliyor -Furkan
            const perPage = Number(this.pageLength)
            if (slotProps && slotProps.perPageChanged) {
                slotProps.perPageChanged({
                    currentPerPage: perPage
                })
            }
            localStorage.setItem('officialFee_perPage', String(perPage))
            this.getOfficialFeeList()
        },
        exportExcel() {
            const listForExcelData = {
                pageLength: 1000,
                pageNo: 1,
                moduleId: this.moduleSelect,
                creditCardId: this.creditCardSelect,
                employeeId: this.employeeSelect,
                officialFeeTypeId: this.officialFeeTypeSelect,
                officialFeeOwnerTypeId: this.officialFeeOwnerTypeSelect,
                currencyId: this.currencySelect,
                officialFeeRefundStatusId: this.officialFeeRefundStatusSelect,
                priceStart: this.priceStart,
                priceEnd: this.priceEnd,
                recordNo: this.recordNo,
                receiptNo: this.receiptNo,
                receiptDateStart: this.receiptDateStart,
                receiptDateEnd: this.receiptDateEnd,
                documentDateStart: this.documentDateStart,
                documentDateEnd: this.documentDateEnd,
                name: this.name,
                officailFeeTypeId: this.officialFeeTypeId,
                documentNo: this.documentNo,
                clientAccounting: this.clientAccounting,
                name: this.name,
                currencyId: this.currencySelect,
                paymentInstutionId: this.paymentInstutionSelect,
                isMatchedInvoices: this.isMatchedInvoicesSelect
            }
            const listForExcelController = {
                name: 'OfficialFee'
            }
            const listForExcelPayload = {
                data: listForExcelData,
                controller: listForExcelController
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/getList', listForExcelPayload).then((response) => {
                const controller = {
                    name: 'OfficialFee',
                    actionName: 'CanExport'
                }
                const data = {
                    columnList: this.columns,
                    dataList: response.data.officialFeeList
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    if (response.data.resultStatus == true) {
                        this.$downloadFile("OfficialFee", response.data.base64, 'xlsx')
                    } else {
                        this.$WarningAlert(response.data.resultMessage)
                    }
                })
                loader.hide()
            })
        },
        clearSearchForm() {
            this.recordNo = '';
            this.receiptNo = '';
            this.employeeSelect = 0;
            this.officialFeeTypeSelect = 0;
            this.documentNo = '',
                this.clientAccounting = '',
                this.documentDateStart = null,
                this.documentDateEnd = null,
                this.receiptDateStart = null,
                this.receiptDateEnd = null,
                this.moduleSelect = 0,
                this.priceEnd = 0,
                this.priceStart = 0,
                this.creditCardSelect = 0,
                this.officialFeeOwnerTypeSelect = 0,
                this.officialFeeRefundStatusSelect = 0,
                this.currencySelect = 0,
                this.paymentInstutionSelect = 0,
                this.isMatchedInvoices = false,
                this.einvoiceDateEnd = null,
                this.einvoiceDateStart = null,
                // Tabloyu yenile
                this.getOfficialFeeList();
        },
        getEInvoicePdf(invoiceUUID) {
            const data = {
                Uuid: invoiceUUID,
            }
            const controller = {
                name: 'NesEFatura',
                actionName: 'DownloadIncomingInvoiceAsPdf'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile(invoiceUUID, response.data.base64, 'pdf')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.mr-05 {
    margin-right: 0.5rem !important;
}

.custom-search {
    .btn {
        margin-left: 5px;
    }
}
</style>
